import React from 'react';
import { CtaBlock } from './CtaBlock';
export function EmotionalOpeningSection() {
  return <section className="w-full bg-editorial-bgAlt py-section-mobile md:py-section-desktop px-6 md:px-8 border-t border-editorial-divider bg-gradient-to-b from-editorial-bgAlt to-editorial-bg" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-editorial-text mb-10 md:mb-12 text-center md:text-left" data-id="element-25">
          You felt it before it had a name.
        </h2>

        <div className="space-y-8 md:space-y-10 text-lg md:text-xl font-sans text-editorial-text leading-relaxed" data-id="element-26">
          <p data-id="element-27">
            The dinner table where someone stopped speaking. The coworker who
            disappeared after one wrong sentence. The moment you typed something
            true — and deleted it.
          </p>

          <p data-id="element-28">
            You weren't being paranoid.
            <br className="hidden md:block" data-id="element-29" />
            You were watching a country forget how to disagree without
            destroying.
          </p>

          <p data-id="element-30">
            September 10, 2025 didn't happen overnight.
            <br className="hidden md:block" data-id="element-31" />
            It was the final page of a story written across years — in
            newsrooms, in HR departments, in comment sections, in the silence of
            people who were too afraid to push back.
            <br className="hidden md:block" data-id="element-32" />
            <br className="hidden md:block" data-id="element-33" />
            This investigation documents every step of that story.
          </p>
        </div>

        <div className="mt-12 md:mt-16 w-full max-w-md mx-auto" data-id="element-34">
          <CtaBlock buttonText="Get the Full Investigation — $13.99" data-id="element-35" />
        </div>
      </div>
    </section>;
}